import Routing from "./Routing";

const useRoutes = () => {
  return {
    Routing
  };
};

export default useRoutes;
